<div
  class="bg-surface border-default flex min-h-0 w-full flex-col overflow-hidden rounded-lg border shadow-lg"
  (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()">
  <div class="border-default flex items-center gap-2 border-b px-3 py-2">
    <i [class]="entityIcon()" class="text-accent-main text-lg"></i>
    <div class="flex min-w-0 flex-1 flex-col">
      <span class="text-text-primary truncate text-sm font-semibold">{{
        name() ?? uid()
      }}</span>
      <div class="flex items-center gap-1">
        <span class="text-text-tertiary truncate font-mono text-xs">{{ uid() }}</span>
        <button
          type="button"
          class="text-text-tertiary hover:text-text-primary cursor-pointer"
          [attr.aria-label]="'table.reference.popover.copy_uid' | translate"
          (click)="copyUid()">
          <i [class]="ICONS.copy" class="text-xs"></i>
        </button>
      </div>
    </div>
    <button
      type="button"
      class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer"
      [attr.aria-label]="'visualization.timeline.step_detail.close' | translate"
      (click)="dismiss.emit()">
      <i [class]="ICONS.x"></i>
    </button>
  </div>

  <div class="flex min-h-0 flex-1 flex-col overflow-y-auto px-3 py-2">
    @if (loading()) {
      <p class="text-text-tertiary text-xs">
        {{ 'table.reference.popover.loading' | translate }}
      </p>
    } @else if (error()) {
      <p class="text-xs text-red-500">{{ 'table.reference.popover.error' | translate }}</p>
    } @else if (fieldRows().length === 0) {
      <p class="text-text-tertiary text-xs">
        {{ 'table.reference.popover.no_fields_selected' | translate }}
      </p>
    } @else {
      <dl class="flex flex-col gap-1.5">
        @for (row of fieldRows(); track row.key) {
          <div class="flex justify-between gap-2">
            <dt class="text-text-secondary text-xs">{{ row.label }}</dt>
            <dd class="text-text-primary truncate text-xs">
              {{ formatFieldValue(row.value) }}
            </dd>
          </div>
        }
      </dl>
    }
  </div>

  <div class="border-default flex items-center justify-between gap-2 border-t px-3 py-2">
    <button
      type="button"
      [appDropdown]="fieldPicker"
      class="text-text-secondary hover:text-text-primary cursor-pointer text-xs">
      {{ 'table.reference.popover.fields_label' | translate }}
    </button>
    <div class="flex items-center gap-2">
      <!-- Disabled placeholder for future cross-entity navigation (see Scope refinements). -->
      <button
        type="button"
        class="btn-disabled text-xs"
        disabled
        [title]="'table.reference.popover.go_to_reference_hint' | translate">
        {{ 'table.reference.popover.go_to_reference' | translate }}
      </button>
      @if (canAddToFilter()) {
        <button type="button" class="btn-secondary text-xs" (click)="addToFilter.emit()">
          {{ 'table.reference.popover.add_to_filter' | translate }}
        </button>
      }
      @switch (includeInFilterStatus()) {
        @case ('available') {
          <button
            type="button"
            data-testid="include-in-filter"
            class="btn-secondary text-xs"
            (click)="includeInFilter.emit()">
            {{ 'table.reference.popover.include_in_filter' | translate }}
          </button>
        }
        @case ('already-shown') {
          <button
            type="button"
            data-testid="include-in-filter"
            class="btn-disabled text-xs"
            disabled>
            {{ 'table.reference.popover.already_shown' | translate }}
          </button>
        }
        @case ('blocked-free-text') {
          <button
            type="button"
            data-testid="include-in-filter"
            class="btn-disabled text-xs"
            disabled
            [title]="
              'table.reference.popover.include_in_filter_blocked_free_text' | translate
            ">
            {{ 'table.reference.popover.include_in_filter' | translate }}
          </button>
        }
      }
    </div>
  </div>
</div>

<ng-template #fieldPicker>
  <div
    class="bg-surface border-default flex max-h-60 flex-col gap-1 overflow-y-auto rounded-md border p-2 shadow-md">
    @for (field of availableFields(); track field.key) {
      <app-checkbox
        [label]="field.label"
        [checked]="selectedFields().includes(field.key)"
        [onChange]="fieldToggleHandler(field.key)" />
    }
  </div>
</ng-template>
